/**
 * Naptime course API.
 */
import API from 'js/lib/api';

import constants from 'pages/open-course/common/constants';

const api = API(constants.coursesApi, {
  type: 'rest',
});

export default api;
